import {
	extractMentions,
	mergeMentions
} from "../components/RichTextEditor/extractMentions";

function buildAnnouncementPayload(
	data: Partial<MeeAnnouncement>,
	heroImageReference: string | null,
	heroImageRemoved: boolean
): Record<string, unknown> {
	const textHtml = (data.contentBlocks ?? [])
		.filter((b) => b.type === "text")
		.map((b) => b.content ?? "");
	const { userIds, hashtagIds } = mergeMentions(textHtml.map(extractMentions));

	return {
		title: data.title ?? "",
		body: data.body ?? "",
		push_title: data.pushTitle ?? "",
		push_body: data.pushBody ?? "",
		audience_type: data.audienceType ?? "everyone",
		audience_platform: data.audiencePlatform ?? "",
		audience_user_ids: data.audienceUserIds ?? [],
		audience_group_ids: data.audienceGroupIds ?? [],
		// Always include content_blocks — sending an empty array is
		// semantically "the announcement has no blocks" and must be
		// distinguishable from "caller didn't mention blocks" on the
		// backend. Stripping this field was the original bug: blocks
		// edited in the admin UI never arrived at the server, so on
		// reopen they appeared to vanish.
		content_blocks: data.contentBlocks ?? [],
		mention_user_ids: userIds,
		hashtag_ids: hashtagIds,
		scheduled_at: data.scheduledAt ?? null,
		expires_at: data.expiresAt ?? null,
		hero_image_reference: heroImageReference ?? null,
		hero_image_removed: heroImageRemoved
	};
}

export const adaptCreateAnnouncementPayload = (
	data: Partial<MeeAnnouncement>,
	heroImageReference: string | null
): Record<string, unknown> => {
	return buildAnnouncementPayload(data, heroImageReference, false);
};

export const adaptEditAnnouncementPayload = (
	data: Partial<MeeAnnouncement>,
	heroImageReference: string | null,
	heroImageRemoved = false
): Record<string, unknown> => {
	return buildAnnouncementPayload(data, heroImageReference, heroImageRemoved);
};
